import { Link } from "react-router-dom";
import { Shield, CheckCircle, Lock } from "lucide-react";
import FAQSection from "@/components/FAQSection";
import SEO from "@/components/SEO";
import { useRatifiSDK } from "@/hooks/useRatifiSDK";

function ClaimHeader() {
  return (
    <header className="claim-header" data-testid="claim-header">
      <Link to="/" className="claim-logo" data-testid="claim-logo">
        <span className="logo-your">Your</span>
        <span className="logo-solicitor">Solicitor.co.uk</span>
      </Link>
      <span className="claim-header-divider" aria-hidden="true" />
      <p className="claim-header-tag">PCP &amp; HP Claims</p>
      <div className="claim-header-trust">
        <Lock size={13} />
        <span>Secure &amp; Confidential</span>
      </div>
    </header>
  );
}

function ClaimTrustBar() {
  return (
    <div className="claim-trust-bar" data-testid="claim-trust-bar">
      <div className="claim-trust-item"><CheckCircle size={15} /><span>No Win, No Fee**</span></div>
      <div className="claim-trust-item"><Shield size={15} /><span>SRA Regulated</span></div>
      <div className="claim-trust-item"><CheckCircle size={15} /><span>Takes less than 60 seconds</span></div>
      <div className="claim-trust-item"><Shield size={15} /><span>Average claim ~£830*</span></div>
    </div>
  );
}

function ClaimDisclaimer() {
  return (
    <footer className="claim-disclaimer" data-testid="claim-footer">
      <div className="claim-disclaimer-inner">
        <p>
          *The FCA has indicated that under its Consumer Redress Scheme, eligible claims may
          average around £830 per finance agreement. Using our specialist AI-powered solution,
          we identify an average of 2.5 agreements per client, meaning our clients could achieve
          an average settlement of £2,075. These are not guaranteed amounts and all claims are
          subject to eligibility.
        </p>
        <p>
          **No Win, No Fee means you only pay our fees if your claim is successful. For claims
          settled without litigation our success fee is up to 36% (inc. VAT) of the compensation
          recovered. For claims settled through litigation the maximum deduction is capped at 48%
          (inc. VAT). You may cancel without charge within the 14-day cooling-off period. You do
          not need to use a law firm or claims management company — you can complain directly to
          your lender or the Financial Ombudsman Service for free.
        </p>
        <p>
          YourSolicitor is a trading name of BlueLion Law Limited, authorised and regulated by
          the Solicitors Regulation Authority (SRA No. 815166). Registered in England &amp; Wales
          (No. 12276560). Registered office: The Centro Buildings, 20–23 Mandela Street, London
          NW1 0DU.
        </p>
      </div>
    </footer>
  );
}

export default function ClaimForm() {
  useRatifiSDK();

  return (
    <>
      <SEO
        title="Start Your PCP Claim | YourSolicitor.co.uk"
        description="Check if you were mis-sold PCP or HP car finance. No Win, No Fee SRA regulated solicitors. Start your claim in under 60 seconds."
        canonical="/claim"
      />
      <div className="claim-page">
        <ClaimHeader />
        <ClaimTrustBar />
        <main className="claim-main">
          <div className="claim-form-wrap" data-testid="claim-form-container">
            {/* form tag kills autocomplete at browser level before iframe loads */}
            <form autocomplete="off" style={{display:"contents"}}>
              <div id="ratifi-claims-container" data-testid="ratifi-container" />
            </form>
          </div>
        </main>
        {/* COMPLIANCE: FAQs always visible below form — required during LOA signing (step 3) */}
        <div id="claim-faqs" data-testid="claim-faqs">
          <FAQSection />
        </div>
        <ClaimDisclaimer />
      </div>
    </>
  );
}
